import { BankHoliday } from "@jasper/client-models";
import { CustomDateSelection } from "@jasper/shared";
import { Button, Checkbox, Loader, Modal, Text } from "@mantine/core";
import { Group, Paper, Stack, ThemeIcon, Title } from "@mantine/core";
import { IconEdit, IconNumber3Small, IconSend } from "@tabler/icons-react";
import { useState } from "react";
import { LabelledValue } from "./components/LabelledValue";

export const OrderDelivery = ({
  deliveryDate,
  onDeliveryDateChange,
  estimatedOptimalDeliveryDate,
  estimatedRushDeliveryDate,
  bankHolidays,
  onMonthChange,
  onConfirmOrder,
  deliveryDateTooSoonError,
  showDesignRequest,
  isDesignRequested,
  onDesignRequestedToggle,
}: {
  deliveryDate?: Date;
  onDeliveryDateChange: (newDeliveryDate: Date) => void;
  estimatedOptimalDeliveryDate?: Date;
  estimatedRushDeliveryDate?: Date;
  bankHolidays: BankHoliday[];
  onMonthChange?: (date: Date) => void;
  onConfirmOrder: () => void;
  deliveryDateTooSoonError?: boolean;
  showDesignRequest: boolean;
  isDesignRequested: boolean;
  onDesignRequestedToggle: () => void;
}) => {
  const [isChangeDeliveryDateModalOpened, setIsChangeDeliveryDateModalOpened] =
    useState(false);

  return (
    <>
      <Modal
        opened={isChangeDeliveryDateModalOpened}
        size="auto"
        onClose={() => setIsChangeDeliveryDateModalOpened(false)}
      >
        {!estimatedOptimalDeliveryDate || !estimatedRushDeliveryDate ? (
          <Loader />
        ) : (
          <CustomDateSelection
            selectDate={newDeliveryDate =>
              onDeliveryDateChange(newDeliveryDate)
            }
            optimalDeliveryDate={estimatedOptimalDeliveryDate}
            bankHolidays={bankHolidays.map(bankHoliday => ({
              beginDate: new Date(bankHoliday.startDate),
              endDate: new Date(bankHoliday.endDate),
            }))}
            onMonthChange={onMonthChange}
            minimalRushDeliveryDate={estimatedRushDeliveryDate}
            selectedDate={deliveryDate ?? null}
          />
        )}
      </Modal>
      <Paper shadow="xs" p="xl" withBorder>
        <Stack>
          <Group>
            <ThemeIcon radius="xl" variant="light" c="primary">
              <IconNumber3Small />
            </ThemeIcon>
            <Title c="primary" order={5}>
              Livraison
            </Title>
          </Group>
          <Stack gap="xl">
            <Group justify="space-between" align="flex-start">
              <LabelledValue
                label="Date de livraison"
                error={
                  deliveryDateTooSoonError
                    ? "La date de livraison est trop proche. Veuillez en choisir une autre."
                    : undefined
                }
              >
                <Text fw={500}>
                  {deliveryDate ? (
                    new Date(deliveryDate).toLocaleDateString(undefined, {
                      weekday: "long",
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })
                  ) : (
                    <Loader size="xs" />
                  )}
                </Text>
              </LabelledValue>
              <Button
                leftSection={<IconEdit size={16} />}
                variant="subtle"
                color="primary"
                onClick={() => setIsChangeDeliveryDateModalOpened(true)}
              >
                Modifier la date de livraison
              </Button>
            </Group>
            {showDesignRequest && (
              <Checkbox
                label="Demander un design avant fabrication"
                size="md"
                checked={isDesignRequested}
                onChange={onDesignRequestedToggle}
              />
            )}
            <Button
              leftSection={<IconSend size={16} />}
              size="compact-xl"
              onClick={onConfirmOrder}
            >
              Valider ma commande
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </>
  );
};
